// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"593":"37d36f0b","602":"0277ec10","649":"9f523d46"}[chunkId] + ".chunk.css";
};